import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import ControllerView from "@/views/ControllerView.vue";
import RadioShowMode from "@/components/AnimateMode/RadioShowMode.vue";

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/controller',
    name: 'controller',
    component: ControllerView,
    meta: {
      mode: 'controller'
    }
  },
  {
    path: '/radio',
    name: 'RadioShowMode',
    component: RadioShowMode,
    meta: {
      mode: "controller"
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  const bodyTag = document.getElementsByTagName('body')
  if (to.name === 'controller') {
    if (bodyTag[0].className.indexOf('hide_body_flow') >= 0) bodyTag[0].classList.remove('hide_body_flow')
  } else {
    if (bodyTag[0].className.indexOf('hide_body_flow') < 0) bodyTag[0].classList.add('hide_body_flow')
  }
  next()
})

export default router
